const CurrencyFormat = ({ amount }) => {
  const formated = new Intl.NumberFormat("fr-EU", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
  return formated;
};

export default CurrencyFormat;
